<template>
  <v-dialog v-model="isOpen" width="40%" persistent>
    <v-card>
      <v-card-title class="pb-0">
        <span class="text-bold"> {{ title }} </span>
      </v-card-title>

      <v-card-text>
        <v-form class="mt-5 text-body-1">
          <v-row>
            <v-col>
              <span class="text-bold" v-html="booking.readableDates"></span>
            </v-col>
          </v-row>
          <v-row>
            <v-col> {{ $t("booking.summaryPurpose") }} </v-col>
            <v-col> {{ booking.readableReason }} </v-col>
          </v-row>
          <v-row v-if="booking.reason == 'TRAINING'">
            <v-col> {{ $t("booking.summaryNumUsers") }} </v-col>
            <v-col> {{ booking.numUsers }} </v-col>
          </v-row>
          <v-row>
            <v-col> {{ $t("booking.summaryComplement") }} </v-col>
            <v-col> {{ complementFormatted }} </v-col>
          </v-row>
          <v-row>
            <v-col> {{ $t("booking.summaryDesks") }} </v-col>
            <v-col> {{ desksFormatted }} </v-col>
          </v-row>
          <v-row>
            <v-col> {{ $t("booking.summaryEquipments") }} </v-col>
            <v-col> {{ equipmentsFormatted }} </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="red darken-1" text @click="close">
          {{ $t("booking.stepperBack") }}
        </v-btn>
        <v-btn color="red darken-1" text @click="createBooking">
          {{ $t("booking.stepperFinal") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import i18n from "@/i18n";

export default {
  name: "SummaryDialog",
  components: {},
  props: {
    booking: null,
  },
  data: () => ({
    isOpen: false,
  }),
  computed: {
    title() {
      return "%1 - %2 %3 - %4"
        .replace("%1", this.booking.room.center.name)
        .replace("%2", i18n.t("booking.bookRoom"))
        .replace("%3", this.booking.room.name)
        .replace("%4", i18n.t("booking.summary"));
    },
    complementFormatted() {
      return !this.booking.complement?.length
        ? i18n.t("booking.none")
        : this.booking.complement;
    },
    desksFormatted() {
      return this.booking.wholeRoom
        ? i18n.t("booking.wholeRoom")
        : this.resourcesFormatted(this.booking.desks);
    },
    equipmentsFormatted() {
      return this.resourcesFormatted(this.booking.equipments);
    },
  },
  methods: {
    open() {
      this.isOpen = true;
    },
    close() {
      this.isOpen = false;
    },
    createBooking() {
      this.$emit("createBooking");
    },
    resourcesFormatted(resources) {
      if (!resources.length) return i18n.t("booking.none");
      const names = [];
      for (const resource of resources) names.push(resource.name);
      return names.sort((a, b) => a.localeCompare(b)).join(", ");
    },
  },
};
</script>

<style lang="scss" scoped>
.text-bold::v-deep bold {
  font-weight: 500;
}
</style>
